import React from 'react';
import useRevenueData from '../../../hooks/useRevenueData';
import useDashboardSummary from '../../../hooks/useDashboardSummary';
import RevenueChart from './RevenueChart';
import DashboardSummary from './DashboardSummary';

export default function DashboardView() {
  const { chartData, fyKeys, loading, error, reload } = useRevenueData();
  const { summary, loading: summaryLoading } = useDashboardSummary();

  return (
    <div className="flex flex-col gap-6 h-full overflow-y-auto">
      {/* Section header */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-500">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
          <h2 className="text-base font-semibold text-gray-800">Revenue &amp; Bill</h2>
        </div>
      </div>

      {/* Metric tabs (Sales Revenue active, others as placeholders) */}
      <div className="flex items-center gap-6 text-sm border-b border-gray-200 pb-2">
        <button className="flex items-center gap-1.5 text-blue-600 font-medium border-b-2 border-blue-600 pb-1">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
          </svg>
          Sales Revenue
        </button>
      </div>

      {/* Chart */}
      <RevenueChart
        chartData={chartData}
        fyKeys={fyKeys}
        loading={loading}
        error={error}
        onReload={reload}
      />

      {/* Summary cards */}
      <DashboardSummary summary={summary} loading={summaryLoading} />
    </div>
  );
}
